import { Id } from "@dgs/core";

export enum RecipientType {
	NONE = "none",
	ALL_DEVICES = "allDevices",
	ALL_DEVICES_WITHOUT_USERS = "allDevicesWithoutUsers",
	ALL_DEVICES_WITH_USERS = "allDevicesWithUsers",
	SELECTED_USERS = "selectedUsers",
	PARTICIPANT_MANAGEMENT_CONTACTS = "participantManagementContacts",
}

export interface RecipientRequest {
	type: RecipientType;
	selectedUserIds: Id[];
	eventId: Id | null;
}
